<template>
    <div class="information">
        <van-dropdown-menu>
            <van-dropdown-item @change="onRefresh()" get-container="body" v-model="information_request.location" :options="locale" :disabled="category == 3 || category == 4 || category == 5 ? true:false"/>
            <van-dropdown-item @change="onRefresh(true)" get-container="body" v-model="category" :options="classify"/>
            <!-- <van-dropdown-item @change="onRefresh()" get-container="body" v-model="information_request.statue" :options="state" :disabled="category == 3 || category == 4 ? true:false"/> -->
            <van-dropdown-item @change="onRefresh()" get-container="body" v-model="information_request.statue" :options="state" />
        </van-dropdown-menu>
        <div class="list">
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
                    
                    :error.sync="error"
                    error-text="请求失败，点击重新加载"
                >
                    <listInformation v-for="(item,index) in records" :key="index" :record="item" :category="category"></listInformation>
                </van-list>
            </van-pull-refresh>
        </div>
    </div>
    <!-- <van-popup position="bottom">
    <van-picker
        show-toolbar
        :columns="editBlackColumns"
        @cancel="editBlackPicker = false"
        @confirm="editBlackConfirm"
    />
    </van-popup> -->
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Vue from 'vue';
import { DropdownMenu, DropdownItem } from 'vant';
import listInformation from '../components/listInformation.vue';

Vue.use(DropdownMenu);
Vue.use(DropdownItem);
export default {
    name: "InvestmentIndex",
    components: {
        listInformation
    },
    data() {
        return {
            category: 1,
            locale: [
                { text: '地点', value: '' },
            ],
            classify: [
                // { text: '信息状态', value: '' },
                { text: '招商项目', value: 1 },
                { text: '营商环境', value: 2 },
                { text: '联系我们', value: 3 },
                { text: '合作企业', value: 4 },
                { text: '运营位', value: 5 },
            ],
            state: [
                { text: '信息状态', value: '' },
                { text: '草稿', value: 1 },
                { text: '审核中', value: 10 },
                // { text: '审核通过', value: 20 },
                { text: '审核驳回', value: 30 },
                { text: '发布', value: 40 },
                { text: '下线', value: 50 },
            ],
            information_request: {
                current: 0,
                size: 10,
                type: '',
                location: '',
                statue: '',
                status: ''
            },
            records: [],
            loading: false,
            finished: false,
            refreshing: false,
            error: false,
            error_true: false,
        };
    },
    computed: {
        ...mapGetters('investment', ['getInformationOption'])
        
    },
    created() {
        this.setInvestmentTitle('信息发布列表');

        this.information_request.location = this.getInformationOption.location
        this.information_request.statue = this.getInformationOption.statue
        this.category = this.getInformationOption.category

        this.getAllLocation().then(res => {
            
            for (const key in res) {
                this.locale.push(
                    {
                        text: res[key],
                        value: key
                    }
                )
                
            }
            
        })
    },
    watch: {},
    methods: {
        ...mapActions("investment", [
            "setInvestmentTitle",
            "getAttractList",
            "getAllLocation",
            "getBusinessList",
            "getContactUsList",
            "getCompanyPartnerList",
            "getFindOperatingConfigList",
            "setInformationOption"
        ]),
        onLoad() {
            console.log('加载下一页')
            if(!this.error_true){
                this.information_request.current++
            }
            if(this.category == 1){
                this.refreshAttractList()

            }else if(this.category == 2){
                this.refreshBusinessList()
            }else if(this.category == 3){
                this.refreshContactUsList()
            }else if(this.category == 4){
                this.refreshCompanyPartnerList()
            }else if(this.category == 5){
                this.refreshFindOperatingConfigList()
            }
        },
        //下拉刷新时触发
        onRefresh(value) {
            if(value){
                if(this.category == 5){
                    this.state = [
                        { text: '全部', value: '' },
                        { text: '审核中', value: 0 },
                        { text: '发布', value: 1 },
                        { text: '审核驳回', value: 2 },
                        { text: '下线', value: 3 },
                    ]
                    this.information_request.statue = ''
                }else{
                    this.state = [
                        { text: '信息状态', value: '' },
                        { text: '草稿', value: 1 },
                        { text: '审核中', value: 10 },
                        // { text: '审核通过', value: 20 },
                        { text: '审核驳回', value: 30 },
                        { text: '发布', value: 40 },
                        { text: '下线', value: 50 },
                    ]
                    this.information_request.statue = ''
                }
            }
            this.information_request.current = 1
            this.records = []
            if(this.category == 1){
                this.refreshAttractList()

            }else if(this.category == 2){
                this.refreshBusinessList()
            }else if(this.category == 3){
                this.refreshContactUsList()
            }else if(this.category == 4){
                this.refreshCompanyPartnerList()
            }else if(this.category == 5){
                this.refreshFindOperatingConfigList()
            }

            this.setInformationOption({
                location: this.information_request.location,
                category: this.category,
                statue: this.information_request.statue,
            })
        },
        refreshAttractList(){
            this.getAttractList(this.information_request).then(res=>{
                this.refreshing = false
                this.loading = false
                this.error_true = false
                if(res.pages > this.information_request.current){
                    this.finished = false
                }else{
                    this.finished = true
                }
                this.records = this.records.concat(res.records)

            }).catch(res=>{
                this.refreshing = false
                this.loading = false
                this.finished = false
                this.error=true
                this.error_true = true
            })
        },
        refreshBusinessList(){
            this.getBusinessList(this.information_request).then(res=>{
                this.refreshing = false
                this.loading = false
                this.error_true = false
                if(res.pages > this.information_request.current){
                    this.finished = false
                }else{
                    this.finished = true
                }
                this.records = this.records.concat(res.records)
            }).catch(res=>{
                this.refreshing = false
                this.loading = false
                this.finished = false
                this.error=true
                this.error_true = true
            })
        },
        refreshContactUsList(){
            this.getContactUsList(this.information_request).then(res=>{
                this.refreshing = false
                this.loading = false
                this.error_true = false
                if(res.pages > this.information_request.current){
                    this.finished = false
                }else{
                    this.finished = true
                }
                this.records = this.records.concat(res.records)
            }).catch(res=>{
                this.refreshing = false
                this.loading = false
                this.finished = false
                this.error=true
                this.error_true = true
            })
        },
        refreshCompanyPartnerList(){
            this.getCompanyPartnerList(this.information_request).then(res=>{
                this.refreshing = false
                this.loading = false
                this.error_true = false
                if(res.pages > this.information_request.current){
                    this.finished = false
                }else{
                    this.finished = true
                }
                this.records = this.records.concat(res.records)
            }).catch(res=>{
                this.refreshing = false
                this.loading = false
                this.finished = false
                this.error=true
                this.error_true = true
            })
        },
        refreshFindOperatingConfigList(){
            this.information_request.status = this.information_request.statue
            
            this.getFindOperatingConfigList(this.information_request).then(res=>{
                this.refreshing = false
                this.loading = false
                this.error_true = false
                if(res.pages > this.information_request.current){
                    this.finished = false
                }else{
                    this.finished = true
                }
                this.records = this.records.concat(res.records)
            }).catch(res=>{
                this.refreshing = false
                this.loading = false
                this.finished = false
                this.error=true
                this.error_true = true
            })
        }
    },
    mounted() {},
};
</script>

<style lang="less" scoped>
.information {
    min-height: 100%;
    font-family: PingFangSC-Regular;
    padding-bottom: 42px;
    background: #F5F6F9;

    .list{
        padding: 0 12px;
    }
    /deep/.van-dropdown-menu__bar{
        justify-content: flex-start;
    }
    /deep/.van-dropdown-menu__item{
        flex: none;
        margin-right: 20px;
    }
}
</style>